var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E3A11F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 26H13C11.895 26 11 25.105 11 24V13C11 11.895 11.895 11 13 11H24C25.105 11 26 11.895 26 13V24C26 25.105 25.105 26 24 26Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4671 19.504V19.297C18.4671 18.619 18.8861 18.252 19.3061 17.97C19.7161 17.694 20.1271 17.334 20.1271 16.67C20.1271 15.753 19.3841 15.011 18.4681 15.011C17.5521 15.011 16.8081 15.752 16.8081 16.669",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4658 21.843C18.3828 21.843 18.3158 21.91 18.3168 21.993C18.3168 22.076 18.3838 22.143 18.4668 22.143C18.5498 22.143 18.6168 22.076 18.6168 21.993C18.6168 21.91 18.5498 21.843 18.4658 21.843",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14H27C28.105 14 29 14.895 29 16V27C29 28.105 28.105 29 27 29H16C14.895 29 14 28.105 14 27V26",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitch);
export default __webpack_public_path__ + "static/media/Pitch.429426522863c4b687067d7805596003.svg";
export { ForwardRef as ReactComponent };